import axios from 'axios'
import qs from 'qs'
import rootApi from '@/rootUrl'
const root = rootApi //接口API
// const root = "https://stuapi.kidcastle.cn"
const url = {
  getReadbooksType: `${root}/Base/getReadbooksType`, // 图书馆->图书分类获取
  getReadbooks: `${root}/Base/getReadbooks`, // 图书馆->图书资源获取
  getLikeBooks: `${root}/Books/getLikeBooks`, // 图书馆->获取学生喜欢图书信息
  getBookAge: `${root}/Books/getBookAge`, // 图书馆->获取图书年龄段分类信息
  like: `${root}/Books/like`, // 图书馆->获取学生对单个图书的喜欢状态
  getOneBook: `${root}/Books/getOneBook`, // 图书馆->获取单个图书信息
  changeLike: `${root}/Books/changeLike`, // 图书馆 -> 获取学生对单个图书的喜欢状态
  AddBooksGold: `${root}/Student/AddBooksGold`, // 图书馆 -> 看图书 加 金币
}
const bookStore = {
  getReadbooksType(params :any) {
    return axios.get(url.getReadbooksType, { params })
  },
  getReadbooks(params :any) {
    return axios.get(url.getReadbooks, { params })
  },
  getLikeBooks(params :any) {
    return axios.get(url.getLikeBooks, { params })
  },
  getBookAge(params :any) {
    return axios.get(url.getBookAge, { params })
  },
  like(params :any) {
    return axios.get(url.like, { params })
  },
  getOneBook(params :any) {
    return axios.get(url.getOneBook, { params })
  },
  changeLike(params :any) {
    return axios.get(url.changeLike, { params })
  },
  AddBooksGold(params :any) {
    return axios.post(url.AddBooksGold, qs.stringify(params))
  },
}

export default bookStore;